import { ThunkAction } from "redux-thunk";
import { IComment } from "./commentsTypes";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { makeApiCall } from "../../helpers/postRequest";
import { endPoints } from "../../constants/endPoints";

export const fetchCommentsAysnc =
  (
    typeId: string | number,
    onCallback: (isSuccess: boolean, data?: IComment[]) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const res = await api.get(`/general/get-comments?type_id=${typeId}`);
      const data: IComment[] = res.data.data;

      onCallback(true, data);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const upsertCommentAysnc =
  (
    comment: IComment,
    initialComment: IComment,
    isUpdate: boolean,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());

      await makeApiCall(
        {
          url: endPoints.comments.upsertComment,
          method: "POST",
          automation: {
            primaryFieldName: "comment_t_id",
            isUpdate: isUpdate,
          },
        },
        initialComment,
        comment
      );

      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };
